import * as React from 'react';
import { ReactComponent as LogoCamera } from 'assets/images/icons/entityButtonCamera.svg';

export type AiScanningLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
};

/**
 * Theme-aware AI Scan Receipts & Bills camera logo.
 * Dark mode: white camera (sparkle stays brand yellow) via --ai-scanning-logo-color.
 */
export const AiScanningLogo = React.forwardRef<SVGSVGElement, AiScanningLogoProps>(
  function AiScanningLogo({ size, className, style, width, height, ...rest }, ref) {
    const resolvedSize = size ?? width ?? height ?? 24;
    return (
      <LogoCamera
        ref={ref}
        className={['ai-scanning-logo', className].filter(Boolean).join(' ')}
        width={width ?? resolvedSize}
        height={height ?? resolvedSize}
        style={{
          color: 'var(--ai-scanning-logo-color, #042a2a)',
          flexShrink: 0,
          ...style,
        }}
        {...rest}
      />
    );
  }
);

AiScanningLogo.displayName = 'AiScanningLogo';
